import "./StartupProjects.css";
import { Fade } from "react-awesome-reveal";
import { bigProjects } from "../../portfolio";

export default function StartupProject() {
  function openProjectInNewWindow(url) {
    var win = window.open(url, "_blank");
    win.focus();
  }

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="projects">
        <div>
          <h1 className="skills-heading">{bigProjects.title}</h1>
          <p className="subTitle project-subtitle">{bigProjects.subtitle}</p>
          <div className="startup-projects-main">
            <div className="startup-project-text">
              {bigProjects.projects.map((project, index) => {
                return (
                  <div key={index} className="grid-item" onClick={() => openProjectInNewWindow(project.link)}>
                    <img alt={project.title} src={project.image}></img>
                    <p className="startup-project-title">{project.title}</p>
                  </div>
                );
              })}
            </div>
            <div className="starup-project-image"></div>
          </div>
        </div>
      </div>
    </Fade>
  );
}
